// Routing paths
const Path = {
  HOME: "/",
  CAMPAIGN: "/campaign",
  CONTACTUS: "/contactUs",
  ARCHITECTING: "/architectingNext",
  CERTIFICATES: "/certificates",
  B2B: "/B2B-Services",
};
export default Path;
